<template>
  <v-container>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="users"
      sort-by="name"
      class="elevation-1"
      :custom-filter="filterTable"
      :search="search"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title class="mr-2">{{
            reseller ? $store.state.auth.user.reseller.name : ""
          }}</v-toolbar-title>
          <v-divider vertical class="mr-2"></v-divider>
          <v-toolbar-title>{{ $t("Users") }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-if="!$vuetify.breakpoint.xs"
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('Search')"
            clearable
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            data-cy="button-new-user"
            :icon="$vuetify.breakpoint.mdAndDown"
            color="primary"
            dark
            class="mb-2"
            @click.stop="dialog = true"
          >
            <span v-if="$vuetify.breakpoint.lgAndUp">{{ $t("New user") }}</span>
            <v-icon v-if="$vuetify.breakpoint.mdAndDown" x-large
              >mdi-plus-circle</v-icon
            >
          </v-btn>
          <template v-if="$vuetify.breakpoint.xs" v-slot:extension>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('Search')"
              clearable
              single-line
              hide-details
            ></v-text-field>
          </template>
        </v-toolbar>
      </template>
      <template v-slot:item.entities="{ item }">
        <v-chip
          class="ma-1"
          v-for="(entity, index) in item.reseller_entities"
          :key="index"
          >{{ entity.name }}</v-chip
        >
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon class="mr-2" @click.stop="editItem(item)" v-on="on"
              >mdi-pencil</v-icon
            >
          </template>
          {{ $t("Modify user") }}
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon @click.stop="deleteItem(item)" v-on="on">mdi-delete</v-icon>
          </template>
          {{ $t("Delete user") }}
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon
              class="ml-2"
              v-visible="!item.name"
              @click.stop="sendRegistrationMail(item)"
              v-on="on"
              >mdi-refresh</v-icon
            >
          </template>
          Renvoyer le lien d'inscription
        </v-tooltip>
      </template>
    </v-data-table>
    <add-edit-user-dialog
      v-model="dialog"
      @close="close"
    ></add-edit-user-dialog>
    <v-snackbar light v-model="loadingMail" centered :timeout="-1">
      <lottie-animation
        :path="`${publicPath}animations/sending-email.json`"
        :autoPlay="true"
        :loop="true"
        :speed="1.5"
        :height="150"
        :width="150"
      ></lottie-animation>
    </v-snackbar>
    <v-snackbar light v-model="mailSent" centered :timeout="4000">
      <lottie-animation
        :path="`${publicPath}animations/email-sent.json`"
        :autoPlay="true"
        :loop="true"
        :height="150"
        :width="150"
      ></lottie-animation>
    </v-snackbar>
    <v-snackbar light v-model="mailError" centered :timeout="4000">
      <lottie-animation
        :path="`${publicPath}animations/error-sending.json`"
        :autoPlay="true"
        :loop="true"
        :height="150"
        :width="150"
      ></lottie-animation>
    </v-snackbar>
  </v-container>
</template>

<script>
import snackbar from "@/mixins/snackbar";
import LottieAnimation from "lottie-vuejs/src/LottieAnimation";
import { mapState } from "vuex";
import AddEditUserDialog from "@/components/AddEditUserDialog";

export default {
  name: "ResellersUsers",
  components: { AddEditUserDialog, LottieAnimation },
  mixins: [snackbar],
  data() {
    return {
      loading: false,
      dialog: false,
      search: "",
      loadingMail: false,
      mailSent: false,
      mailError: false,
      publicPath: process.env.BASE_URL.substring(1),
    };
  },
  computed: {
    ...mapState({
      users: (state) => state.users.items,
      reseller: (state) => state.auth.user.reseller.id,
    }),
    headers() {
      return [
        {
          text: this.$t("Name"),
          align: "start",
          sortable: true,
          value: "name",
        },
        {
          text: this.$t("E-mail"),
          align: "start",
          sortable: true,
          value: "email",
        },
        {
          text: this.$t("Entities"),
          align: "start",
          sortable: false,
          value: "entities",
        },
        {
          text: this.$t("Role"),
          align: "start",
          sortable: true,
          value: "role.label",
        },
        {
          text: this.$t("Actions"),
          align: "center",
          value: "actions",
          sortable: false,
        },
      ];
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  created() {
    if (this.users.length === 0) {
      this.loading = true;
      this.$store
        .dispatch("users/fetchAll")
        .then(() => (this.loading = false))
        .catch(() => (this.loading = false));
    }
  },
  methods: {
    editItem(item) {
      this.$store.commit("users/setEditedId", item.id);
      this.$store.commit("users/setEditedItem", Object.assign({}, item));
      this.dialog = true;
    },
    deleteItem(item) {
      if (confirm(this.$t("Are you sure you want to delete this item ?"))) {
        this.$store
          .dispatch("users/deleteItem", item.id)
          .then(() =>
            this.snackbar("success", this.$t("snackbar-message-user.deleted"))
          )
          .catch(() =>
            this.snackbar("error", this.$t("snackbar-message-user.error"))
          );
      }
    },
    sendRegistrationMail(item) {
      this.loadingMail = true;
      this.$store
        .dispatch("users/sendRegistrationMail", item.id)
        .then(() => {
          this.loadingMail = false;
          this.mailSent = true;
          this.snackbar("success", this.$t("Registration email resent"));
        })
        .catch(() => {
          this.loadingMail = false;
          this.mailError = true;
          this.snackbar(
            "error",
            this.$t("Error while resending the registration email")
          );
        });
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.$store.dispatch("users/resetEditedItem");
      }, 300);
    },
    filterTable(value, search, item) {
      const needle = search.toLowerCase();

      let result =
        item.name.toLowerCase().includes(needle) ||
        item.email.toLowerCase().includes(needle) ||
        item.role.name.toLowerCase().includes(needle);

      item.reseller_entities.forEach((entity) => {
        result = result || entity.name.toLowerCase().includes(needle);
      });

      return result;
    },
  },
};
</script>